// @flow strict
import * as React from 'react'

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@reach/disclosure'
import { type PropsWithChildren } from '@mondough/public-web-components'
import styles from './DisclosureItem.module.scss'
import SubtitleSection from './SubtitleSection'
import { MarkdownContent } from './MarkdownContent'

export type DisclosureItemProps = {|
  title: string,
  content: string,
|}

export default function DisclosureItem(
  props: PropsWithChildren<
    DisclosureItemProps,
    React.Element<typeof SubtitleSection>,
  >,
) {
  const { title, content } = props
  return (
    <Disclosure>
      <DisclosureButton className={styles.disclosureButton}>
        {title}
        <svg
          viewBox="0 0 20 20"
          fill="currentColor"
          className={styles.disclosureButtonIcon}
        >
          <path
            fill-rule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </DisclosureButton>
      <DisclosurePanel>
        <MarkdownContent>{content}</MarkdownContent>
      </DisclosurePanel>
    </Disclosure>
  )
}
